import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectActiveGame, selectOpponent, selectPlayer } from '../ActiveGame/selectors';
import { setFirstPlayer } from './actions';
import { selectSettingFirstPlayer } from './selectors';
import { Button, Muted } from '../Controls';

const SelectStartPlayer = ({ game, player, opponent, setFirstPlayerAction, settingFirstPlayer }) => {
  if (game.get('active_player_id') || !game.get('start_chooser_id')) {
    return null;
  }

  const isStartChooser = game.get('start_chooser_id') === player.getIn(['user', 'id']);
  const firstPlayerId = game.get('first_player_id');

  if (firstPlayerId) {
    return <Muted>{firstPlayerId === player.getIn(['user', 'id']) ? 'You go' : `${opponent.getIn(['user', 'name'])} goes`} first.</Muted>;
  }

  if (!isStartChooser) {
    return <Muted>Your opponent won the flip and is choosing who goes first.</Muted>;
  }

  return (
    <>
      <Muted>You won the flip. Who goes first?</Muted>
      {[player, opponent].map(who => (
        <Button
          key={who.getIn(['user', 'id'])}
          onClick={() => setFirstPlayerAction(who.getIn(['user', 'id']))}
          disabled={settingFirstPlayer}
        >
          {who === player ? 'Me' : who.getIn(['user', 'name'])}
        </Button>
      ))}
    </>
  );
};

SelectStartPlayer.propTypes = {
  game: PropTypes.instanceOf(Map).isRequired,
  player: PropTypes.instanceOf(Map).isRequired,
  opponent: PropTypes.instanceOf(Map).isRequired,
  setFirstPlayerAction: PropTypes.func.isRequired,
};

export default connect(
  createStructuredSelector({
    game: selectActiveGame,
    player: selectPlayer,
    opponent: selectOpponent,
    settingFirstPlayer: selectSettingFirstPlayer,
  }),
  {
    setFirstPlayerAction: setFirstPlayer,
  },
)(SelectStartPlayer);
